module.exports = __webpack_public_path__ + "img/planning.205320dc.jpg";